module.exports = __webpack_public_path__ + "static/media/text-align-center.771415fc.svg";